import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import rt from "../../locales/routes.json"

import StoreButtons from "../StoreButtons";

export default function Discount10() {
    const [t] = useTranslation( 'global' );

    return (
        <React.Fragment>
            <div className="v-main-image v-pioneers">
                <div className="pioneers-copy">
                    <div className="copy-text">
                        <div className="v-txt">
                            <p>{t('home.slider-discount10.first')}</p>
                            <svg width="158" height="32" viewBox="0 0 158 32"><defs><clipPath id="b"><rect width="158" height="32"/></clipPath></defs><g id="a" clipPath="url(#b)"><rect width="158" height="32" fill="rgba(0,0,0,0)"/><g transform="translate(1 1)"><path d="M332.222,26.923V38.009h-5.829V34.736a8.7,8.7,0,0,1-6.936,3.247c-5.937,0-10.058-4.54-10.058-11.061s4.7-11.113,11.372-11.113,11.45,4.644,11.45,11.113Zm-16.492,0c0,3.169,2.127,5.465,5.068,5.465s5.068-2.3,5.068-5.465-2.127-5.491-5.068-5.491S315.73,23.7,315.73,26.923Z" transform="translate(-175.616 -8.974)" fill="#FFF"/><path d="M215.127,27.167c0-6.438-4.436-10.927-10.793-10.927-6.75,0-11.424,4.462-11.424,10.849s4.255,10.771,10.533,11.087c.393.026.787.052,1.18.052a10.781,10.781,0,0,0,7.433-2.694c.078-.052.13-.134.212-.186a7282.408,7282.408,0,0,0,.424-.476,9.579,9.579,0,0,0,2.076-3.775H208.6c-.553,1.4-2.339,2.348-4.307,2.348a4.914,4.914,0,0,1-4.752-3.775H214.9a12.08,12.08,0,0,0,.238-2.508Zm-15.891-1.133c.368-2.984,2.1-5.016,4.752-5.016a4.842,4.842,0,0,1,4.834,5.016Z" transform="translate(-109.496 -9.218)" fill="#FFF"/><path d="M24.214,15.2a10.254,10.254,0,0,0-6.962,2.72A10.285,10.285,0,0,0,0,25.547V37.689H6.672V25.547a3.6,3.6,0,1,1,7.2,0V37.689h6.672V25.547a3.6,3.6,0,1,1,7.2,0V37.689h6.672V25.547A10.2,10.2,0,0,0,24.214,15.2Z" transform="translate(0 -8.628)" fill="#FFF"/><path d="M148.364,37.689V25.547a3.6,3.6,0,1,1,7.2,0V37.689h6.672V25.547a10.3,10.3,0,1,0-20.591,0V37.689h6.724Z" transform="translate(-80.395 -8.628)" fill="#FFF"/><path d="M289.41,27.613a3.61,3.61,0,0,1-3.6-3.615V16.686h4.41v-4.8h-4.41v-.026h-.13V7.45h-6.356v4.406h-.186v.026H276.49v4.8h2.651V24a10.337,10.337,0,0,0,10.3,10.347c.342,0,.709-.026,1.051-.052v-6.81a5.1,5.1,0,0,1-1.077.134Z" transform="translate(-156.937 -4.229)" fill="#FFF"/><path d="M257.932,27.613h-.052a3.61,3.61,0,0,1-3.6-3.615V16.686h4.41v-4.8h-4.41v-.026h-.13V7.45H247.8v4.406h-.186v.026H244.96v4.8h2.651V24a10.337,10.337,0,0,0,10.3,10.347h.052V27.613h-.026Z" transform="translate(-139.04 -4.229)" fill="#FFF"/><path d="M95.76,17a39.952,39.952,0,0,1,9.348,1.029,11.321,11.321,0,0,0,2.153-6.836c0-6.624-4.7-11.19-11.476-11.19S84.31,4.566,84.31,11.19a11.251,11.251,0,0,0,2.127,6.836A41.005,41.005,0,0,1,95.76,17Zm0-11.774c2.966,0,5.094,2.27,5.094,5.517s-2.127,5.491-5.094,5.491-5.094-2.27-5.094-5.491,2.075-5.517,5.094-5.517Z" transform="translate(-47.855)" fill="#FFF"/></g></g></svg>
                            <p>{t('home.slider-discount10.second')}</p>
                        </div>
                        <p className="v-htxt">{t('home.slider-discount10.percentage')}</p>
                        <p className="v-hstxt">{t('home.slider-discount10.third')}</p>
                        <p className="v-txt hideMobile">{t('monetta.copy-intro')} {t('monetta.monetta')}, {t('monetta.copy')}</p>
                    </div>
                </div>
                <div className="pioneers-simon">
                    <div>
                        <Link to={rt.pioneers}>
                            <button>{t('home.slider-discount10.cta')}</button>
                        </Link>
                    </div>
                    <StoreButtons />
                </div>
            </div>
        </React.Fragment>
    )

    // const isMobile = false

    // if (!isMobile) {
    //     return (
    //         <React.Fragment>
    //             
    //         </React.Fragment>
    //     );
    // } else {
    //     return (
    //         <React.Fragment>
    //             <div className="v-main-image v-mobile-pioneers">
    //                 <div className="pioneers-simon">
    //                     <div>
    //                         <Link to={rt.pioneers}>
    //                             <button>Conooce cómo {t('header.home')}</button>
    //                         </Link>
    //                     </div>
    //                     <StoreButtons />
    //                 </div>
    //             </div>
    //         </React.Fragment>
    //     );
    // }

}